import AnnualAttendance from './AnnualAttendance';
import ChatWidget from '../../Components/attendance/ChatWidget';

const AnnualAttendanceIndex = () => {
  return (
    <>
      <AnnualAttendance />
      <ChatWidget />
    </>
  );
};

export default AnnualAttendanceIndex;